import showMoreSocialMedia from './show-more-social-media';

const showMoreSocialMediaConfig = {
  name: 'showMoreSocialMedia',
  class: showMoreSocialMedia,
  querySelector: {
    showMoreTrigger: '.show-more__button',
  },
  querySelectorAll: {
    socialMediaCards: '.social-media__hide',
  },
  options: {},
};

export default showMoreSocialMediaConfig;
